
import InfoIcon from '~/assets/images/information-line.svg?inline'

export default {
  data() {
    return {
      icon: InfoIcon,
    }
  },
}
